import { render, staticRenderFns } from "./PickYourOwnColorPicker.vue?vue&type=template&id=621c032d"
import script from "./PickYourOwnColorPicker.vue?vue&type=script&lang=ts"
export * from "./PickYourOwnColorPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports